import { defineStore } from "pinia";
import {
    AccountListItem,
    BankAccountBlacklistResponse,
    BankAccountBlacklistState
} from "@/admin/types";
import _ from "lodash";
import {
    FetchState
} from "@/shared/types";
import Vue from "vue";
import * as bankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { AxiosError } from "axios";

export const initialState: BankAccountBlacklistState = {
  fetchState: FetchState.Uninitialized,
  bankAccountBlacklistResponse: null
};
export const useBankAccountBlacklistStore = defineStore("bankAccountBlacklist", {
  state: (): BankAccountBlacklistState => (_.cloneDeep(initialState)),
  getters: {
    blackLists: state => state.bankAccountBlacklistResponse.blacklists === null ? [] : state.bankAccountBlacklistResponse.blacklists,
    blackListLoaded: state => state.fetchState === FetchState.Loaded,
  },
  actions: {
    setBlackList (data: BankAccountBlacklistResponse) {
      this.bankAccountBlacklistResponse = data;
    },
    setFetchState (fetchState: FetchState) {
      this.fetchState = fetchState;
    },
    createBlackList (request: AccountListItem) {
      this.setFetchState(FetchState.Loading);
      const notifierStore = useNotifierStore();
      return bankService.putBankAccountBlacklist(request)
        .then(r => {
           this.setBlackList(r.data);
            const notifierStore = useNotifierStore();
            notifierStore.setSuccess("Blacklist item successfully stored.", notifierStore.shortTimeout);
            return Promise.resolve(r.data);
        })
        .catch((err: AxiosError | any) => {
          storeHelper.handleError({ error: err, rethrow: false, timeout: notifierStore.longTimeout });
          return Promise.reject();
        }).finally(() => this.setFetchState(FetchState.Loaded));
    },
    deleteBlackList (bankAccountBlacklistId: number) {
      this.setFetchState(FetchState.Loading);
      const notifierStore = useNotifierStore();
      return bankService.deleteBankAccountBlacklist(bankAccountBlacklistId)
        .then(r => {
          this.setBlackList(r.data);
            notifierStore.setSuccess("Blacklist item successfully deleted.", notifierStore.shortTimeout);
          return Promise.resolve(r.data);
        })
        .catch((err: AxiosError | any) => {
          storeHelper.handleError({ error: err, rethrow: false, timeout: notifierStore.shortTimeout });
          return Promise.reject();
        }).finally(() => this.setFetchState(FetchState.Loaded));
    },
    loadBlackList () {
      this.setFetchState(FetchState.Loading);
      const notifierStore = useNotifierStore();
      return bankService.getBankAccountBlackList()
        .then(r => {
          this.setBlackList(r.data);
          this.setFetchState(FetchState.Loaded);
          return Promise.resolve(r.data);
        })
        .catch((err: AxiosError | any) => {
          storeHelper.handleError({ error: err, rethrow: false, timeout: notifierStore.shortTimeout });
        }).finally(() => this.setFetchState(FetchState.Loaded));
      },
    }
});